export default "__VITE_ASSET__BPIvTa97__"